define('shared/initializer/form/newHouseAdapters/mixins/EFIDUserCreatable',[
    '$',
    'Promise',
    'shared/my/efid',
    'shared/util/checkout/member',
    'shared/remote/efid/create',
    'shared/remote/efid/util',
    'shared/remote/efid/cache',
    'shared/remote/efid/const',
    'shared/page/market',
    'shared/page/language'
],
function ( 
    $,
    Promise,
    myEFID,
    memberUtil,
    createEFID,
    efidUtil,
    efidCache,
    efidConst,
    getMarket,
    getLanguage
) {
    'use strict';

    function getMappedFormData(map, $form) {
        var postingData = {};

        for(var key in map) {
            if (!map.hasOwnProperty(key)) {
                continue;
            }

            var $elements = $form.find('[name=' + map[key] + ']');

            if ($elements.length > 1) {
                postingData[key] = $elements
                    .map(function(){
                        return this.value;
                    })
                    .get();
            }
            else {
                postingData[key] = $elements[0].value;
            }
        }

        return postingData;
    }

    function getEFData() {
        return Promise.resolve()
            .then(function(){
                return myEFID.get();
            })
            .then(function(efGuid){
                if (!efGuid) {
                    return Promise.resolve(null);
                }
                
                return efidCache.get(efGuid);
            });
    }

    function Ctor() {

    }

    var p = Ctor.prototype;

    p.doSubmit = function(data){
        if(memberUtil.isUpdatingMemberInfo()){
            return Promise.resolve()
                .then(function() {
                    return data;
                });
        }
        var efidOptions;
        var me = this;

        return Promise.resolve()
            .then(function(){
                return Promise.all([getMarket(), getLanguage()]);
            })
            .then(function(values){
                var market = values[0];
                var language = values[1];
                efidOptions = getMappedFormData({
                    email: 'email',
                    password: 'password'
                }, me.$form);
                efidOptions.name = getMappedFormData({
                    given: 'firstname',
                    family: 'lastname'
                }, me.$form);
                efidOptions.market = market;
                efidOptions.language = language;
            })
            .then(function(){
                return getEFData();
            })
            .then(function (efid) {
                if (efid && efid.email === efidOptions.email) {
                    return Promise.resolve();
                }
                else {
                    return createEFID(efidOptions);
                }
            })
            .then(null, function(err) {
                var error;

                if (err instanceof Error) {
                    error = err;
                }
                else {
                    error = new Error(err);
                }

                error.fatal = false;

                if (err.type === efidUtil.REGISTERED) {
                    return efidUtil.waitForAccessToken(efidConst.CUSTOM_REDIRECT)
                        .then(function(){
                            return getEFData();
                        })
                        .then(function (efid) {
                            if (efid && efid.email === efidOptions.email) {
                                return Promise.resolve();
                            }
                            else {
                                return Promise.reject(error);
                            }
                        });
                }
                else {
                    return Promise.reject(error);
                }
            })
            .then(null, function(error){
                return Promise.reject(error);
            });
    };

    return Ctor;
});

